// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2zTgY","header":"Messages_header__39yQh"};